if (typeof DrawerComponent !== 'function') {
	class DrawerComponent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				overlay: '.drawer-overlay',
				heading: '.drawer-inner__heading',
				content: '.drawer-inner__content',
				drawersGroup: '.drawers',
			};

			this.classes = {
				visible: 'drawer--visible',
				largeLayout: 'drawer--large',
				blockedScroll: 'blocked-scroll',
				hasDrawerVisible: 'drawers--has-drawer-visible',
			};

			// Elements
			this.heading = this.querySelector(this.selectors.heading);
			this.content = this.querySelector(this.selectors.content);
			this.drawersGroup = this.closest(this.selectors.drawersGroup);

			// Flags
			this.type = this.dataset.type;
			this.lastVisibleDrawer = null;

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.addEventListener('click', this.handleClick.bind(this));
			this.addEventListener('keyup', this.onKeyUp.bind(this));
		}

		openDrawer(triggerType) {
			const { type, drawersGroup, classes } = this;

			if (type === triggerType) {
				if (triggerType == 'cart') this.lastVisibleDrawer = null;
				const visibleDrawers = this.getVisibleDrawers();
				if (visibleDrawers && visibleDrawers.length > 0) {
					this.updateDrawersVisibility(visibleDrawers);
				}

				this.classList.add(classes.visible);
				this.disableScroll();
			}
		}

		closeDrawer(scroll) {
			const { type, classes } = this;

			this.classList.remove(classes.visible);
			this.setLargeLayout();

			if (this.lastVisibleDrawer) {
				if (type === 'cart') {
					this.enableScroll();
				} else {
					this.lastVisibleDrawer.classList.add(classes.visible);

					this.lastVisibleDrawer = null;
				}
			} else {
				this.enableScroll();
			}
		}

		getVisibleDrawers() {
			const { drawersGroup, classes } = this;

			if (drawersGroup) {
				const visibleDrawers = drawersGroup.querySelectorAll(`.${classes.visible}`);

				if (visibleDrawers) {
					this.lastVisibleDrawer = visibleDrawers[visibleDrawers.length - 1];

					return visibleDrawers;
				}
			}

			return null;
		}

		updateDrawersVisibility(visibleDrawers) {
			const { classes } = this;

			if (visibleDrawers) {
				visibleDrawers.forEach((drawer) => {
					drawer.closeDrawer(false);
				});
			}
		}

		handleClick(evt) {
			if (!evt.target.matches('[drawer-close]')) return;
			this.closeDrawer();
		}

		replaceDrawerHeading(headingContent) {
			const { heading } = this;

			heading.innerText = headingContent;
		}

		replaceDrawerHeading(headingContent) {
			const { heading } = this;

			heading.innerText = headingContent;
		}

		replaceDrawerContent(responseContent) {
			const { content } = this;

			content.innerHTML = responseContent;

			content.querySelectorAll('script').forEach((oldScriptTag) => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach((attribute) => {
					newScriptTag.setAttribute(attribute.name, attribute.value);
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});
		}

		disableScroll() {
			const { classes } = this;

			document.body.classList.add(classes.blockedScroll);
		}

		enableScroll(scroll = true) {
			const { classes } = this;

			if (scroll) document.body.classList.remove(classes.blockedScroll);
		}

		renderContents(parsedState) {
			this.productId = parsedState.id;
			this.getSectionsToRender().forEach((section) => {
				const sectionElement = section.selector
					? document.querySelector(section.selector)
					: document.getElementById(section.id);

				sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
			});

			this.openDrawer('cart');
		}

		getSectionInnerHTML(html, selector = '.shopify-section') {
			return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
		}

		getSectionsToRender() {
			return [
				{
					id: 'cart-drawer',
					section: 'cart-drawer',
					selector: '#cart-drawer .drawer-inner',
				},
				{
					id: 'cart-bubble',
					section: 'cart-bubble',
					selector: '#cart-bubble',
				},
				{
					id: 'cart-bubble-mobile',
					section: 'cart-bubble-mobile',
					selector: '#cart-bubble__mobile',
				},
			];
		}

		setLargeLayout(setLargeLayout = false) {
			const { classes } = this;

			if (setLargeLayout) {
				this.classList.add(classes.largeLayout);
			} else {
				this.classList.toggle(classes.largeLayout, false);
			}
		}

		onKeyUp(event) {
			const { classes } = this;

			if (event.code.toUpperCase() !== 'ESCAPE') return;

			const visibleDrawer = event.target.closest(`.${classes.visible}`);
			if (!visibleDrawer) return;

			visibleDrawer.closeDrawer();
		}
	}

	if (!customElements.get('drawer-component')) {
		customElements.define('drawer-component', DrawerComponent);
	}
}

if (typeof drawerTrigger !== 'function') {
	class drawerTrigger extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				heading: '.heading',
				content: '.content',
			};

			// Elements
			this.heading = this.querySelector(this.selectors.heading);
			this.content = this.querySelector(this.selectors.content);

			// Flags
			this.type = this.dataset.type;
			this.layout = this.dataset.layout;

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.addEventListener('click', () => this.drawerSetup());
		}

		drawerSetup() {
			const { heading, content, type, layout } = this;

			if (type) {
				const drawer = document.querySelector(`drawer-component[data-type='${type}']`);

				if (drawer) {
					if (heading) drawer.replaceDrawerHeading(heading.innerText);
					if (content) drawer.replaceDrawerContent(content.innerHTML);
					if (layout == 'large') drawer.setLargeLayout(true);

					drawer.openDrawer(type);
				}
			}
		}
	}
	if (typeof customElements.get('drawer-trigger') === 'undefined') {
		customElements.define('drawer-trigger', drawerTrigger);
	}
}
